<div class="payment-layout">
  <div class="payment-content">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
